import {
  all, takeEvery, call, put, takeLatest
} from 'redux-saga/effects';
import actions from './actions';
import {
  getClients, postClient, putClient, getSettings, fetchUnassignedPharmacies, deleteClient
} from '../../../api/clients/clients.api';
import * as _ from 'lodash';
import { message } from 'antd';

function* fetchClients({ account = "", retrieveAll }) {
  try {
    const data = yield call(getClients, { parentId: account, retrieveAll });
    const pharmacies = _.filter(data.clients, c => c.pharmacyId && c.pharmacyId !== '');

    yield put(actions.fetchClientsSuccess(data.clients, pharmacies, retrieveAll));
    const settings = yield call(getSettings, {});
    yield put(actions.fetchSettingsSuccess('settings' in settings ? settings.settings : []));
  } catch (error) {
    console.log(error);
  }
}

function* getClient(client) {
  try {
    const clientObj = yield call(getClients, { clientId: client.clientId });
    yield put(actions.getClientSuccess(clientObj.client[0]));
  } catch (error) {
    console.log(error);
  }
}

function* saveClient(data) {
  const { clientInfo, clientType } = data;
  const isExistingClient = 'clientId' in clientInfo;
  try {
    const { client } = yield call(isExistingClient ? putClient : postClient, { client: clientInfo, type: clientType });
    yield call(fetchClients, { account: clientInfo.parentId });
    yield call(fetchPharmacies);
    yield put(actions.saveClientSuccess(isExistingClient ? clientInfo : {}));
    yield message.success(`Facility ${isExistingClient ? 'edited' : 'added'} successfully!`);
  } catch (error) {
    yield message.error(`Unable to ${isExistingClient ? 'edit' : 'add'} Facility!`);
    yield put(actions.saveClientError());
  }
}

function* fetchPharmacies() {
  try {
    const { pharmacies } = yield call(fetchUnassignedPharmacies);
    yield put(actions.fetchUnassignedPharmaciesSuccess(pharmacies));
  } catch (error) {
    yield put(actions.fetchUnassignedPharmaciesError());
  }
}

function* removeClient({ clientId }) {
  try {
    yield call(deleteClient, clientId);
    yield put(actions.deleteClientSuccess(clientId));
    yield message.success(`Facility deleted successfully!`);
  } catch (error) {
    yield message.error(`Unable to delete Facility!`);
  }
}

function* fetchClientsByAccount({ account = "", retrieveAll }) {
  try {
    const data = yield call(getClients, { parentId: account, retrieveAll });
    yield put(actions.fetchClientsForAccountSuccess(data.clients));
  } catch (error) {
    console.log(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_CLIENTS, fetchClients),
    takeEvery(actions.GET_CLIENT, getClient),
    takeEvery(actions.SAVE_CLIENT, saveClient),
    takeLatest(actions.FETCH_UNASSIGNED_PHARMACIES, fetchPharmacies),
    takeEvery(actions.DELETE_CLIENT, removeClient),
    takeEvery(actions.FETCH_CLIENTS_BY_ACCOUNT, fetchClientsByAccount)
  ]);
}
